module.exports = __webpack_public_path__ + "static/media/icons8-plus.932a5a2b.svg";